<app-lista-categoria
  titulo="Paradas"
  color="#29b6f6"
  [items]="items"
  [umbral]="umbral"
  [cargando]="cargando"
  [textoVacio]="textoVacio"
  (verEnMapa)="verEnMapa($event)"
>
  <!-- El select propio: sobra cuando el filtro ya está en el formulario -->
  @if (mostrarFiltroMotor) {
    <mat-form-field appearance="outline" class="estado-motor-field">
      <mat-icon matPrefix>power_settings_new</mat-icon>
      <mat-label>Estado del motor</mat-label>
      <mat-select
        [(ngModel)]="estadoMotor"
        (ngModelChange)="onEstadoMotorChange()"
      >
        <mat-option value="">Todos los estados</mat-option>
        <mat-option value="apagado">Detenido y Apagado</mat-option>
        <mat-option value="encendido">Detenido y Encendido</mat-option>
      </mat-select>
    </mat-form-field>
  }
</app-lista-categoria>
